<template>
    <window size="lg" :title="__('title', { mode: modeText })">

        <editable slot-scope="window" :show-toggle-button="false" default-state="edit" class="container container-sm mt-lg">
            <div class="row" slot-scope="editable">
                <div class="col">
                    <p>
                        <span v-html="__('phrases.intro_1', { mode: modeText })"></span><br />
                        <span v-html="__('phrases.intro_2')"></span>
                    </p>

                    <div class="mt-lg mb-lg">
                        <editable-choose name="reason">
                            <ul slot-scope="{ data, setData }" class="job-cancel-reason__reasons list-reset list-h">
                                <li v-for="reason in app.options.Reason.REASONS.cancelled" :key="reason.id">
                                    <button 
                                        :class="{ 'btn-plain input-radio': true, 'input-radio--selected': data == reason.id }" 
                                        @click="setData(reason.id)">

                                        <span class="input-radio__icon"></span>
                                        <span class="input-radio__label">{{ reason.reason }}</span>
                                    </button>
                                </li>
                            </ul>
                        </editable-choose>
                    </div>

                    <div>
                        <editable-list name="pictures" :icon-src="icon" :additional-base-classes="[ 'job-cancel-reason__pictures' ]" :popups="app.layout.popups" :confirm-remove="true">
                            <template slot="itemTemplates">
                                <editable-image :use-croppie="false" :src-loader="loadImageSrc" :choose-on-mounted="true">
                                    <template slot="fileLabel"> 
                                        <img :src="icon('camera.svg')" />
                                    </template>
                                </editable-image>
                            </template>

                            <template slot="buttons" slot-scope="listParts">
                                <button class="add-picture btn-plain" @click="listParts.newItem(0)">
                                    <img 
                                        :src="icon(undefined in listParts.data && listParts.data[undefined].length ? 'cross.svg' : 'camera.svg')" 
                                        :class="{ 
                                            'mb-sm': true, 
                                            'icon-add': undefined in listParts.data && listParts.data[undefined].length > 0 
                                        }"
                                    />

                                    {{ __('#main.buttons.add_picture') }}
                                </button>
                            </template>
                        </editable-list>
                    </div>
                    
                    <div class="mt-lg mb-lg">
                        <editable-text 
                            name="text"
                            label="Mitteilung an den Projektleiter" 
                            placeholder="Beschreiben Sie das Problem, den Schaden oder das Bild">
                        </editable-text>
                    </div>

                    <div class="mt-lg mb-lg">
                        <editable-check name="triggerRepairRequest" label="Reparaturauftrag anstoßen" :icon-src="icon"></editable-check>
                    </div>

                    <div class="buttons mb-3">
                        <button class="btn btn-secondary" @click="window.hide()">
                            {{ __('#main.buttons.cancel') }}
                        </button>

                        <button class="btn btn-primary" @click="window.hide(editable.data)" :disabled="!editable.data.reason">
                            {{ __('buttons.perform', { mode: modeText }) }}
                        </button>
                    </div>
                </div>
            </div>
        </editable>
    </window>
</template>

<script>
import NeedsTranslations from 'smartdoors-shared/js/components/Mixins/NeedsTranslations';

export default {
    mixins: [ NeedsTranslations ],
    provide: {
        windowId: 'jobCancelReason'
    },
    props: {
        jobCloseStatus: null
    },
    computed: {
        modeText() {
            return this.jobCloseStatus == this.app.options.Job.STATUS.cancelled 
                ? 'abbrechen' 
                : 'unvollständig abschließen';
        }
    },
    methods: {
        loadImageSrc(data) {
            if(data && typeof data == 'object' && 'file' in data) {
                return api.download(this.config.api.urls.files.download + '/' + data.file.route);
            }

            return Promise.resolve(data);
        }
    }
}
</script>

<style lang="scss">
.job-cancel-reason {
    &__reasons {
        > li {
            flex: 0 0 33%;
            margin-right: 0 !important;
            margin-bottom: map-get($spacers, mdsm);
        }
    }

    &__pictures {
        display: flex;
        flex-wrap: wrap;

        &__item {
            flex-direction: column;
        }
        &__item-controls {
            padding-bottom: map-get($spacers, xs);

            > button > img {
                border: 1px solid $black;
                border-radius: 50%;
                padding: map-get($spacers, xs);
            }
        }

        > .editable__element__errors {
            flex: 1 0 100%;
            width: 100%;
        }

        > ul > li,
        > .editable__element__buttons {
            width: 150px;
        }

        > ul {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0;

            > li {
                position: relative;
                display: flex;
                flex-wrap: wrap;
                height: 100%;
                
                > button {
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 1;
                }

                .editable__element-image,
                .editable__element__image-container {
                    position: relative;

                    &, > img {
                        width: 100%;
                        height: 200px;
                    }

                    > img {
                        object-fit: cover;
                    }

                    .spinner {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateX(-50%) translateY(-50%);
                    }

                    .editable__element__input {
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        transform: none;
                        display: flex;
                        align-items: stretch;
                        justify-content: stretch;

                        > label {
                            flex: 1 0 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
            }
        }

        .add-picture {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding-top: map-get($spacers, lg);

            .icon-add {
                transform: rotate(45deg);
                width: 16px;
                height: 16px;
            }
        }
    }
}
</style>